const styles = (theme) => ({
    container: {
        width: theme.custom.actionsAndFiltersWidth,
        [theme.breakpoints.down('md')]: {
            width: theme.custom.actionsAndFiltersWidthForMediumAndDown,
        },
        marginTop: 10,
    },
    filterLabel: {
        color: theme.palette.primary.contrastText,
        fontSize: 14,
    },
    panel: {
        padding: '10px 20px',
        backgroundColor: theme.custom.successBlue,
    },
    select: {
        width: 195,
        marginBottom: 10,
    },
    marginLabels: {
        marginLeft: 16,
    },
    rangeArrow: {
        color: theme.palette.primary.contrastText,
        marginTop: 24,
    },
});

export default styles;
